import { render, staticRenderFns } from "./AnnotationDetailsPanel.vue?vue&type=template&id=5608208c&scoped=true"
import script from "./AnnotationDetailsPanel.vue?vue&type=script&lang=js"
export * from "./AnnotationDetailsPanel.vue?vue&type=script&lang=js"
import style0 from "./AnnotationDetailsPanel.vue?vue&type=style&index=0&id=5608208c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5608208c",
  null
  
)

export default component.exports